const noop = () => {};

export class GameCardStore {
  constructor() {
    this.init();
  }

  init() {
    this.gameCardData = null;
    this.loading = 0;
    this.fns = [];
    this.scrollFunc = noop;
    this.changeBtnProgressFns = []; // 改变按钮状态 函数集合
  }

  // 传入卡片数据处理回调
  getGameDataCallback(fn, context) {
    if (fn) {
      this.fns.push({ fn, context });
    }
  }

  // 接收 卡片数据
  receiveGameData(data) {
    this.loading = 2;
    this.gameCardData = data;
    // 防止回调过快
    Promise.resolve().then(() => {
      // 回调
      this.fns.forEach((item) => {
        try {
          if (typeof item.fn === 'function') {
            item.fn.call(item.context, this.gameCardData);
          }
        } catch (error) {
          console.error(error);
        }
      });
    });
  }

  // 接收 改变按钮状态 的回调
  receiveChangeBtnProgressFns(fn, context) {
    this.changeBtnProgressFns.push({ fn, context });
  }

  // 调用 改变按钮状态 的回调
  callChangeBtnProgressFns(...arg) {
    this.changeBtnProgressFns.forEach((item) => {
      try {
        if (typeof item.fn === 'function') {
          item.fn.call(item.context, ...arg);
        }
      } catch (error) {
        console.error(error);
      }
    });
  }
}
const gameCardStore = new GameCardStore();
window.gameCardStore = gameCardStore;
export default gameCardStore;
